export function formatMemberId(memberId: string): string {
  if (memberId) {
    const [, ...parts] = /^(.{3})(.{4})(.{4})(.{1})$/.exec(memberId.toUpperCase())
    return parts.join("-")
  }
  return null
}
